/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable max-statements */
import assert from 'assert';
import {
    useEffect,
    useState,
    useRef,
    useCallback,
    useMemo,
    Profiler,
} from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import {Alert} from '@baidu/luffy-comp-alert';
import queryString from 'query-string';
import {debounce} from 'lodash-es';
import * as store from '@/store';
import {MorphoEditor} from '@baidu/realtime-editor';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {
    DocumentUpdateData,
    Props,
    SinglePersonData,
    IPublishSquareData,
    DocumentOperateType,
    IUnderlineCommentNotice,
} from '@/interface';
import sdk from '@/sdk';
import {DOC_TYPE} from '@/constants/document/doc';
import KU_QUERY from '@/constants/common/searchParamKeys';
import {PageType as BaikePageType} from '@/pages/baike/const/index';
import {getIsBaikeRepo} from '@/pages/baike/utils';
import {canReadInKnowledge} from '@/domains/space/Repository/knowledgeUtils';
import toast, {ToastType, toastObjects} from '@/components/Toast';
import Loading from '@/components/Loading';
// import {useEntityLinking} from '@/domains/document/DocHome/Document/entityLinking';
import ConfirmDialog from '@/components/ConfirmDialog';
import eventBus, {
    EDITOR_FS_DOM_READY,
    EDITOR_DOM_READY,
    DOCUMENT_INIT_COMPLETE,
    COMMENT_INFO_CHANGE,
    COMMENT_LIST_CHANGE,
} from '@/eventBus';
import {useTodoPosition} from '@/rte/todo/config';
import {useVerifyEditorDialog} from '@/domains/document/DocHome/Document/Dialogs/useVerifyEditorDialog';
import {parse} from '@/utils/kuQuery';
import {isArray, isString} from 'lodash-es';

import {
    DocRole,
    Role,
    EDITOR_MODE,
    selfAdaption,
    UPDATE_FAILED,
    RTE_STATUS,
    FOLLOW_TYPE,
    errorAlertMap,
    WsRetryCountLogMax,
    PageSecurityIsSelected,
} from '@/Constant';
import {TagData} from '@/domains/space/components/Tag';
import {WizKnownError, ErrorCode} from '@/sdk/common/error';
import {
    feLogger,
    pageEdit,
    publish,
    clickShareModalBtn,
    PageType,
    reportStartMeetingBtn,
    reportStopMeetingBtn,
    openPageTagRep,
    mention,
    MentionSource,
    modeType,
    rteWebLog,
    clickShareBtn,
    ShareSource,
    shareInviteFeLogger,
    docPageVisibility,
    docPageFocus,
    openBaiekPageUrl,
    editDocFirstLog,
    createNewDocView,
    clickExternalDocType,
    clickUserDocType,
    clickExternalUserEditor,
    clickUserEditor,
} from '@/buried';
import {reportRteEvent, EventNameMap} from '@/buried/rte';
import {
    reportDemoVersionClick,
    reportCustomVersionTabClick,
} from '@/buried/historyVersion';
import kuJSSDKEventBus, {DOC_PUBLISH} from '@/eventBus/kuJSSDK/bus';
import kuToolEvent, {EventKeys} from '@/kuTools/eventBus/bus';
import SaveTplDialog from './Dialogs/SaveTplDialog';
import DocStatsDialog from './Dialogs/docStatsDialog';
import * as storageUtils from '@/utils/storageUtils';
import Editor from './Editor';
import {setDocumentTitle} from '@/utils/browserUtils';
import {
    updateHistoryState,
    isNewDocSceneObj,
    docCardViewBuriedObj,
} from '@/utils/document/common';
import {getUnderLineCommentCount} from '@/utils/document/comment';
import {RteMethodProps} from '@/rte';
import {docEditAble, isAdminRepository} from '@/store/util';
import mentionCache from '@/utils/document/mentionCache';
import {
    useMentionNotifyOfComment,
    closeAllToastAndResolve,
    getNotifyPromiseAll,
} from '@/hooks/mention';
import useCompatibilityTips from '@/hooks/useCompatibilityTips';
import kuPiper from '@/middleware/kuPiper';
import type {HistoryInterface} from '@/types/document/doc';
import {getUrlParams} from '@/utils/kuQuery';

// import DocInfo, {IProps as IDocInfo} from '../common/Header/DocInfo';
// import DocToolbar, {IProps as IDocToolbar} from '../common/Header/DocToolbar';
// import BottomBar, {IProps as IBottomBar} from './BottomBar';
import EditorTopTip from './editorTopTip';

import {
    rteNotifyPublishTypeAction,
    rteNotifyType,
    rteNotifyBroadcastType,
    rteNotifyDocAction,
    endMeetingNotifyRefer,
    rteNotifyInitAction,
    rteNotifyCommentAction,
    rteNotifyAttachmentAction,
    rteNotifyDomAction,
    rteNotifyCommentPerformanceAction,
    rteNotifyCollaboratorAction,
    rteNotifyHistoryAction,
    rteNotifyWsAction,
    rteNotifySlideAction,
    rteNotifyCoverAction,
    rteNotifyPrintAction,
    rteNotifyCardEditAction,
} from '@/constants/document/notification';
import {
    INotify,
    IInitNotify,
    IPermissionChange,
    IRepoPublicChange,
    IMeetingNotify,
    IPublishSuccessInfo,
    IPublishDraftInfo,
    IRevertNotify,
    ICollaboratorChange,
    IDocChangeNotify,
    ICommentMentionNotify,
    IRTEWeblog,
    IEditorNotify,
    ITodoUpdateData,
    ICommentPerformanceEditorNotify,
    IAttachmentNotify,
    ICollaboratorSaveSuccess,
} from '@/types/document/notification';
import {
    getMeetingInfo,
    IMeetingInfo,
    showOpenTip,
    getDocsInMeeting,
    showCloseTip,
} from '@/utils/document/meetingMode';
import {
    closeSidebarWithNoStorage,
    syncSidebarStatusFromStorage,
} from '@/utils/document/sidebar';
import {bodyScrollObj} from '@/utils/document/common';

import styles from './index.module.scss';
import {saveDebounce} from '../common/Header/SaveStatus/utils';
import NewVersionInfo from './NewVersionInfo';
import {EditorFile} from '@/buried/performance/editorFile';
import {getDocumentInfo} from '@/services';
import {DOC_END_TYPE} from '@/buried/performance/docPagePaint';
import {useAIAgent} from '@/plugins/AIChatPlugin/AigcChat/AIAgent/useAIAgent';

import {SquareEditAlert} from './SquareEditAlert';
import {loadWaterMarkSdk} from '@/utils/waterMarkUtils';
import {LOG_DOC_TYPE} from '@/buried/performance/const';
import {
    isPublishOnlyToPerson,
    isPublishToPerson,
} from '@/utils/document/square';
import {AdapterDataContext} from '@/domains/user/head/Header/widthAdapter';
import {ActionType as KuShareActionType} from '@/utils/kuShare';
import {isInKuShare, removeSearchParamNoRefresh} from '@/utils/urlUtils';
import {handleDocPrint} from '@/utils/document/print';
import Loadable from 'react-loadable';
import {recordShowMentionDocObserver} from '@/buried/aigc';
import {
    recordShowEntityObserver,
    getHighlightConfig,
    EntityEventInfo,
} from '@/rte/highlight/config';
import {perfLogger, PROFILER_KEY, CategoryType} from '@/buried/performance';
import {reset as resetDocSummaryCache} from '@/domains/document/components/DocSummaryCard/summaryData';
import {useAiTaskSubmit} from '@/domains/document/hooks/useAiTaskSubmit';
import {useCheckDocEmpty} from '../../hooks/useCheckDocEmpty';
import {preloadSummaryCard} from '../../components/DocSummaryCard';
import {withAfterDomReady} from '@/components/AfterDomReady';
import {importAsyncComponent} from '@/utils/loadable';
import useRecommendTitleTask from './Editor/EditorBanner/DocTitle/AIRecommendTitle/useRecommendTitleTask';

import {IProps as IDocInfo} from '../common/Header/DocInfo';
import {IProps as IDocToolbar} from '../common/Header/DocToolbar';
import {IProps as IBottomBar} from './BottomBar';
import {handleCardMerge} from './cardUtil';
import {initCardMenuShow} from '@/hooks/document/useCardLikeNewGuid';
import {userHoverCardLog} from '@/buried/docCard';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import AdminMemberList from './AdminMemberList';
import kuSdkEvent from '@/kuSdk/view/DocViewAll/event';
import {MaterialMap} from '@/plugins/AIChatPlugin/AigcChat/Material/component/Card';
import {initFlowJS} from '@/utils/document/flow';
import {getIncrementMentionUserList} from '@/utils/document/mention';
import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';
import {VIEW_BLOCK} from '@/hooks/queryViewController/config';
import {isShowCurrentView} from '@/hooks/queryViewController';

const WithAfterDocToolbar = withAfterDomReady<IDocToolbar>(
    importAsyncComponent(() => import('../common/Header/DocToolbar'))
);
const WithAfterDocInfo = withAfterDomReady<IDocInfo>(
    importAsyncComponent(() => import('../common/Header/DocInfo'))
);
const WithAfterBottomBar = withAfterDomReady<IBottomBar>(
    importAsyncComponent(() => import('./BottomBar'))
);

Editor.displayName = 'Editor';

const {ITransformService, createEditor, IDragCoreService} = MorphoEditor;

// eslint-disable-next-line new-cap
const KuShare = Loadable({
    loader() {
        return import('@/components/kuShare');
    },
    loading() {
        return null;
    },
});

interface StoreProps {
    documentMode?: EDITOR_MODE;
    demoMode?: boolean;
    pageSecuritySettings?: any;
    isKuShareMode?: string;
}

interface OwnProps {
    repository: Repository;
    docGuid: string;
    curDocument: WizDocument;
    curDocumentError?: any | null;
    setHeaderSlot?: (node: any) => void;
}
interface CheckboxItem {
    id: string;
    name: string;
    email?: string;
    checked?: boolean;
}

interface IDocInfos {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
}
type DocumentPageProps = StoreProps & OwnProps;

let timer: any = null;

// websocket更换备用域名后，连接失败的错误LogId
let wsBackupFirstErrLog: string | number = '';

export interface IHaveUnpublish {
    docGuid?: string;
    uid?: string;
    updateMembers?: string[];
    latestVersionId?: number;
}

const getPublishSuccessToast = (publishToSquareData?: IPublishSquareData) => {
    if (isPublishToPerson(publishToSquareData)) {
        return isPublishOnlyToPerson(publishToSquareData)
            ? 'toastPublishToPersonSuccess'
            : 'toastPublishToPersonAndSquareSuccess';
    }
    return 'toastPublishSuccess';
};

let domReadyTimer: any = null;
const rootDirectoryId = '00000000000000';

const {useIsInGray: useIsScrollLogGray} = initGray(
    GRAY_RELEASE_KEYS.kuDocScrollLog
);

const {
    useIsInGray: useIsAutoSavedCommentGray,
} = initGray(GRAY_RELEASE_KEYS.autoSavedComment);

function DocumentPage(props: DocumentPageProps) {
    const intl = useIntl();
    const {
        repository,
        curDocument,
        docGuid,
        documentMode,
        demoMode = false,
        curDocumentError,
        pageSecuritySettings,
        isKuShareMode,
        setHeaderSlot,
    } = props;
    const history = useHistory<HistoryInterface>();
    const {editor: queryEditor, errorAlert} = getUrlParams()!;

    let mode =
        documentMode ||
        (queryEditor === 'icafe_pattern'
            ? EDITOR_MODE.edit
            : EDITOR_MODE.preview);

    // TODO: 读写合一小流量适配
    if (
        store.getRwMode() &&
        [EDITOR_MODE.preview, EDITOR_MODE.edit, EDITOR_MODE.meeting].includes(
            mode
        )
    ) {
        mode = EDITOR_MODE.normal;
    }
    const isPreviewMode = mode === EDITOR_MODE.preview;
    const isNormalMode = mode === EDITOR_MODE.normal;
    const [editable, setEditable] = useState(false);
    const [isNew, setIsNew] = useState<boolean>(false);
    const [isFirstPublish, setIsFirstPublish] = useState<boolean>(false);
    const prevCurDocument = useRef<WizDocument | undefined | null>(null);
    const prevReload = useRef<number>(0);
    const [showDocDeleteDialog, setShowDocDeleteDialog] =
        useState<boolean>(false);
    const [showChangePermissionDialog, setShowChangePermissionDialog] =
        useState<boolean>(false);
    const [showStartMeetingDialog, setShowStartMeetingDialog] =
        useState<boolean>(false);
    const [showMeetingTipAlert, setShowMeetingTipAlert] =
        useState<boolean>(false);
    const [isPublishLoading, setIsPublishLoading] = useState<boolean>(false);
    const [rootId, setRootId] = useState<string>('');
    const currentMode = useRef<EDITOR_MODE>(mode);
    const docTitle = useRef(curDocument?.name);
    const [showCardViewGuide, setShowCardViewGuide] = useState(false);

    const {spaceGuid, groupGuid, repositoryGuid} = repository;
    const [meetingInfo, setMeetingInfo] = useState<IMeetingInfo>();

    const editorRef = useRef<RteMethodProps>(null);

    const isScrollLogGray = useIsScrollLogGray();
    const [showAdminList, setShowAdminList] = useState(false);
    const [adminList, setAdminList] = useState<CheckboxItem[]>([]);
    const toastRef = useRef<HTMLDivElement>(null);
    const listRef = useRef<HTMLDivElement>(null);
    const isAutoSavedCommentGray = useIsAutoSavedCommentGray();

    useEffect(() => {
        if (isScrollLogGray) {
            bodyScrollObj.startCheck();
        }

        return () => {
            bodyScrollObj.stopCheck();
        };
    }, [isScrollLogGray]);

    // 2025.3.11
    // icafe链接： https://console.cloud.baidu-int.com/devops/icafe/issue/hifankui-38801/show
    // 打开块引用链接预期进入预览态，无需进入编辑模式，
    // 历史逻辑↓需要注释掉↓
    // 打开块引用链接自动进入编辑模式，注意执行顺序
    // useEffect(() => {
    //     const queryObj = getUrlParams();
    //     // 点赞卡片链接过来，不进入编辑态
    //     if (queryObj?.[KU_QUERY.document.block_id]) {
    //         if (queryObj?.[KU_QUERY.document.blockIdFrom]) {
    //             return;
    //         }
    //         updateHistoryState(history, {
    //             isEdit: true,
    //         });
    //     }
    // }, [history]);

    const {VerifyEditorDialog, verifiedEvents} = useVerifyEditorDialog(
        true,
        mode
    );

    useEffect(() => {
        if (errorAlert && Number(errorAlert) === 40138) {
            errorAlert &&
                toast({
                    duration: 5000,
                    type: ToastType.Error,
                    content: errorAlertMap[errorAlert],
                });
            removeSearchParamNoRefresh('errorAlert');
        }
    }, [errorAlert]);

    useEffect(() => {
        return () => {
            recordShowEntityObserver.disconnect();
            recordShowMentionDocObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        return () => {
            updateHistoryState(history, {
                isMeeting: false,
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!repository.external) {
            return;
        }
        if (window.isTocPage) {
            feLogger(clickUserDocType({
                type: 1,
            }));
        } else {
            feLogger(clickExternalDocType({
                type: 1,
            }));
        }
    }, [repository.external]);
    // 及时更新editorRef，避免使用到上个文档的实例
    useEffect(() => {
        store.setEditorRef(editorRef);
        return () => {
            store.setEditorRef({current: null});
        };
    }, [editorRef]);

    useTodoPosition();

    useAiTaskSubmit(curDocument);

    // 触发推荐标题任务
    const {triggerTask: triggerRecommendTitle} = useRecommendTitleTask(
        docGuid,
        mode
    );

    useEffect(() => {
        wsBackupFirstErrLog = '';
        store.setEditorDomReady(false);

        return () => {
            store.setDocWsStatus('');
        };
    }, [docGuid, mode]);

    useEffect(() => {
        domReadyTimer = setTimeout(() => {
            store.setDocReady(true);
        }, 2000);
        return () => {
            clearTimeout(domReadyTimer);
        };
    }, []);

    // 清理提及文档的摘要数据缓存
    useEffect(() => {
        if (curDocument?.docGuid) {
            resetDocSummaryCache();
        }
    }, [curDocument?.docGuid]);

    const getRootId = async (parentGuid: string) => {
        const ksServer = await sdk.getKsServer(repository);
        const doc = await ksServer.getDocumentInfoAccess(
            parentGuid,
            curDocument.docGuid
        );
        if (doc.parentGuid === rootDirectoryId) {
            setRootId(doc.docGuid);
            return;
        }
        if (doc?.parentGuid) {
            getRootId(doc.parentGuid);
        }
    };

    useEffect(() => {
        // 百科知识库下非根目录文档需要获取根目录ID
        if (
            curDocument?.parentGuid &&
            curDocument?.parentGuid !== rootDirectoryId &&
            getIsBaikeRepo(curDocument.repositoryGuid)
        ) {
            getRootId(curDocument.parentGuid);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curDocument]);

    useEffect(() => {
        if (curDocument && getIsBaikeRepo(curDocument.repositoryGuid)) {
            feLogger(
                openBaiekPageUrl({
                    pageId: curDocument.docGuid,
                    repoId: curDocument.repositoryGuid,
                    groupId: curDocument.groupGuid,
                    pageName: curDocument.name,
                    pageType: curDocument.name?.includes('[FAQ]')
                        ? BaikePageType.faq
                        : BaikePageType.entity,
                })
            );
        }
    }, [curDocument]);

    // 页面visibilitychange及focus时的埋点
    useEffect(() => {
        const visibilityListener = debounce(() => {
            !document.hidden && feLogger(docPageVisibility({page_id: docGuid}));
        }, 2000);
        const focusListener = debounce(
            () => feLogger(docPageFocus({page_id: docGuid})),
            2000
        );
        window.addEventListener('visibilitychange', visibilityListener);
        window.addEventListener('focus', focusListener);
        return () => {
            window.removeEventListener('visibilitychange', visibilityListener);
            window.removeEventListener('focus', focusListener);
        };
    }, [docGuid]);

    useEffect(() => {
        if (mode === EDITOR_MODE.history) {
            updateHistoryState(history, {
                isHistory: true,
            });
        }
    }, [history, mode]);

    interface CopyObj {
        html: string;
        plain: string;
    }
    /**
     * 获取复制的字符内容(包括 text/html 和 text/plain)
     * PS：处理复制选中范围包含正文标题，且另一部分在编辑器内的场景
     */
    const getCopyObj = useCallback((): CopyObj | false => {
        const editor: any = editorRef.current;
        const selectArea = document.getSelection();
        if (selectArea && selectArea.anchorNode && selectArea.focusNode) {
            const startNode = selectArea.anchorNode; // 选中起点元素
            const startOffset = selectArea.anchorOffset; // 起点偏移量
            const endNode = selectArea.focusNode; // 选中终点元素
            const endOffset = selectArea.focusOffset; // 终点偏移量

            const titleDiv = document.getElementById('documentTitleDiv');

            // 选择范围起点为标题时
            if (startNode.parentElement === titleDiv) {
                const editorInstance = editor.getEditorInstance();
                const editorObj = getMorphoService(
                    serviceNames.ICommonUtilsService
                )?.copyCrossEditor(editorInstance, {
                    container: endNode,
                    offset: endOffset,
                });
                if (!editorObj) {
                    // 若返回的为 falsy，则判断另一个节点不在编辑器内，走浏览器默认复制
                    return false;
                }
                const {html, plain} = editorObj;
                return {
                    html: `<p>${startNode.nodeValue?.substring(
                        startOffset
                    )}</p>${html}`,
                    plain: `${startNode.nodeValue?.substring(
                        startOffset
                    )}\n${plain}`,
                };
            }

            // 选择范围终点为标题时
            if (endNode.parentElement === titleDiv) {
                const editorInstance = editor.getEditorInstance();
                const editorObj = getMorphoService(
                    serviceNames.ICommonUtilsService
                )?.copyCrossEditor(editorInstance, {
                    container: startNode,
                    offset: startOffset,
                });
                if (!editorObj) {
                    // 若返回的为 falsy，则判断另一个节点不在编辑器内，走浏览器默认复制
                    return false;
                }
                const {html, plain} = editorObj;
                return {
                    html: `<p>${endNode.nodeValue?.substring(
                        endOffset
                    )}</p>${html}`,
                    plain: `${endNode.nodeValue?.substring(
                        endOffset
                    )}\n${plain}`,
                };
            }
        }
        return false;
    }, []);

    const docForbidCopy = useMemo(() => {
        if (!pageSecuritySettings) {
            return false;
        }
        const docStatus = PageSecurityIsSelected.includes(
            pageSecuritySettings.docCopyStatus
        );
        return docStatus && !editable;
    }, [pageSecuritySettings, editable]);

    const docForbidPrint = useMemo(() => {
        if (!pageSecuritySettings) {
            return false;
        }
        const docStatus = PageSecurityIsSelected.includes(
            pageSecuritySettings.printPdfStatus
        );
        return docStatus && !editable;
    }, [pageSecuritySettings, editable]);

    const getDocAdminList = useCallback(async () => {
        try {
            const ksServer = await sdk.getKsServer({
                spaceGuid: spaceGuid,
                groupGuid: groupGuid,
                repositoryGuid: repositoryGuid,
            });
            let list: CheckboxItem[] = await ksServer.getDocAdmin(docGuid).then(result =>
                (result || []).map((item: any) => ({
                    id: item.memberGuid,
                    name: item.nickname,
                    checked: false,
                }))
            );
            const userInfoList = await sdk.as.getUserInfoList(list.map(item => item.id));
            const userMap: {[key: string]: User} = {};
            userInfoList.forEach(item => {
                userMap[item.userGuid] = item;
            });
            list = list.map(item => ({
                ...item,
                email: userMap[item.id]?.email || '',
                rlName: userMap[item.id]?.rlName || '',
            }));
            setAdminList(list);
        } catch (error) {
            console.error('Error fetching document admin list:', error);
        }
    }, [docGuid, spaceGuid, repositoryGuid, groupGuid]);

    const handleAdminMemberList = useCallback(() => {
        // 对外知识库，外部视角屏蔽
        if (window.isTocPage) {
            return;
        }
        getDocAdminList().then(() => {
            setShowAdminList(true);
        });
    }, [setShowAdminList, getDocAdminList]);
    const handleCloseAdminList = (event: MouseEvent) => {
        setShowAdminList(false);
        toastObjects[ToastType.Warning]?.remove();
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toastRef.current && !toastRef.current.contains(event.target as Node) &&
                listRef.current && !listRef.current.contains(event.target as Node)
            ) {
                toastObjects[ToastType.Warning]?.remove();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toastRef, listRef]);
    // 处理禁止复制
    useEffect(() => {
        let toastTimeout: any = null;
        const handleCopy = (ev: ClipboardEvent) => {
            if (docForbidCopy) {
                // 处理禁止复制场景下，如果是编辑器特殊情况，不进行阻止
                // 目前仅有一个场景：仅划选代码块内容
                try {
                    const editorStateService = getMorphoService(serviceNames.IEditorStateService);
                    if (editorStateService) {
                        const {MorphoAPI} = editorStateService?.editor || {};

                        if (!MorphoAPI?.isEditorForbidCopy(editorStateService?.editor)) {
                            return;
                        }
                    }
                } catch (err) {
                    console.error(err);
                }

                const targetEl = ev.target;
                if (targetEl && targetEl instanceof HTMLElement) {
                    const isInCommentSection = targetEl.closest('#comment-bottom') !== null;
                    const isInSidebarComment = targetEl.closest('.mp-comment-container-outer') !== null;
                    if (isInCommentSection || isInSidebarComment) {
                        return;
                    }
                    if (
                        targetEl.tagName === 'INPUT'
                        || targetEl.tagName === 'TEXTAREA'
                        || (targetEl.closest('#doc-editor') === null && targetEl.parentElement?.querySelector('[data-morpho-copy="true"]') === null)
                    ) {
                        return;
                    }
                }

                const toastContent = (
                    <div
                        onMouseOver={() => {
                            if (toastTimeout) {
                                clearTimeout(toastTimeout);
                                toastTimeout = null;
                            }
                        }}
                        ref={toastRef}
                    >
                        管理员已设置“禁止只读成员复制”, 若有疑问可与
                        <span className={styles.applyAdmin} onClick={handleAdminMemberList}>
                            管理员
                        </span>
                        联系
                    </div>
                );
                toast({
                    type: ToastType.Warning,
                    content: toastContent,
                    duration: -1,
                });
                ev.clipboardData?.setData('text/plain', '禁止复制');
                ev.preventDefault();
                toastTimeout = setTimeout(() => {
                    toastObjects[ToastType.Warning]?.remove();
                }, 5000);
            } else {
                // 处理复制选中范围包含正文标题，且另一部分在编辑器内的场景
                const copyObj = getCopyObj();
                if (copyObj) {
                    const {html, plain} = copyObj;
                    ev.clipboardData?.setData('text/plain', plain);
                    ev.clipboardData?.setData('text/html', html);
                    ev.preventDefault();
                }
            }
        };
        document.addEventListener('copy', handleCopy);
        return () => {
            document.removeEventListener('copy', handleCopy);
        };
    }, [getCopyObj, docForbidCopy, handleAdminMemberList]);

    useEffect(() => {
        const wideScreenDefault = kuPiper.runProxy(
            kuPiper.proxyNameMap.wideScreenDefault,
            () => {
                console.log(
                    'kuPiper wideScreenDefault-原有逻辑---------------'
                );
                const storageIsWideScreenMode = storageUtils.get(
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    `${selfAdaption +
                    sdk.as.user?.userGuid +
                    repositoryGuid +
                    spaceGuid +
                    groupGuid +
                    docGuid
                    }`
                );
                // 没有值时默认为宽屏模式
                const isWideScreenMode =
                    storageIsWideScreenMode === null
                        ? true
                        : storageIsWideScreenMode;
                store.setIsWideScreenMode(isWideScreenMode);
            }
        );
        wideScreenDefault();
    }, [spaceGuid, groupGuid, repositoryGuid, docGuid]);

    useEffect(() => {
        // 切换页面 重置文档滚动位置
        store.setDocumentPosition(null);
        // 切换页面重置显示新手引导状态
        setShowCardViewGuide(false);
        // 切换页面 重置文档字数
        store.setDocWordNum(null);
        // 切换页面，重置文档是否被修改视图状态  卡片视图&文档视图
        store.setIsViewModified(false);
    }, [docGuid]);

    useEffect(() => {
        return () => {
            store.setIsShowCardLikeNewGuid(false);
        };
    }, [docGuid, mode]);

    const [error, setError] = useState<any>(null);
    const [showIframeMask, setShowIframeMast] = useState(false);
    const [reload, setReload] = useState(0);
    const previousModeRef = useRef<EDITOR_MODE | null>(null);
    const isGettingDocData = useRef(false);

    const [unPublishData, setUnPublishData] = useState<IHaveUnpublish>({});
    const [showUnPublishTip, setShowUnPublishTip] = useState(false);

    const loadingRef = useRef<any>();

    // usePageLoad(repository, docGuid, reload);

    const [showCompatibilityTips] = useCompatibilityTips();

    // 记录文档的滚动位置
    const setDocumentScrollPosition = useCallback(() => {
        const editor: any = editorRef.current;
        const position = editor?.getEditorViewPosition();
        store.setDocumentPosition(position);
    }, []);

    // 跳转到文档在上个模式的位置
    const scrollToDocumentPrePosition = useCallback(() => {
        if (isKuShareMode && isKuShareMode === KuShareActionType.kuShareJoin) {
            return;
        }
        const editor: any = editorRef.current;
        const position = store.getData(store.KEYS.DOCUMENT_POSITION);
        editor?.setEditorViewPosition(position);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function removeToast() {
        toastObjects[ToastType.Error]?.remove();
        toastObjects[ToastType.Warning]?.remove();
    }

    // const positioning = useCallback(() => {
    //     const container = document.querySelector('.mp-layout-content-container');
    //     const containerScrollTop = container!.scrollTop;
    //     if (containerScrollTop > 100) {
    //         setDocumentScrollPosition();
    //     } else {
    //         store.setDocumentPosition(null);
    //     }
    // }, [setDocumentScrollPosition]);

    // 点击立即刷新
    const handleClickRefresh = useCallback(() => {
        setDocumentScrollPosition();
        removeToast();
        setReload(-1);
        store.setIsEditorReloading(true);
    }, [setDocumentScrollPosition]);

    const handleSwitchEdit = useCallback(async () => {
        store.setDocumentMode(EDITOR_MODE.edit);
        updateHistoryState(history, {
            isEdit: true,
        });
        setDocumentScrollPosition();
        try {
            await sdk.as.recentEdit({
                spaceGuid,
                groupGuid,
                repoGuid: repositoryGuid,
                docGuid,
            });
        } catch (error) {
            console.error('error: ', error);
        }
    }, [
        history,
        setDocumentScrollPosition,
        spaceGuid,
        groupGuid,
        repositoryGuid,
        docGuid,
    ]);

    const handleSwitchMeeting = useCallback(() => {
        store.setDocumentMode(EDITOR_MODE.meeting);
        updateHistoryState(history, {
            isEdit: false, // 这里不能记录isMeeting 不然会议在服务端自动结束会同步不到
        });
    }, [history]);

    const handleBackPreview = useCallback(() => {
        store.setDocumentMode(EDITOR_MODE.preview);
        updateHistoryState(history, {
            isEdit: false,
            isNew: false,
            isHistory: false,
        });
        setIsNew(false);
        setIsFirstPublish(false);
        isNewDocSceneObj.setVal(false);
    }, [history]);

    // eslint-disable-next-line consistent-return
    const getTagList = useCallback(async () => {
        try {
            if (repository && !window.isTocPage) {
                const ksServer = await sdk.getKsServer(repository);
                const tags = await ksServer.getTagList(docGuid);
                store.setCurDocTag({
                    tags,
                });
                feLogger(
                    openPageTagRep({
                        page_id: docGuid,
                        s_number: tags
                            ? tags
                                .filter(
                                    (item: {tagFrom: number}) =>
                                        item.tagFrom === 1
                                )
                                .length.toString()
                            : '',
                    })
                );
                return tags;
            }
        } catch (err) {
            console.error(err);
        }
    }, [repository, docGuid]);

    const updateDoTitle = useCallback(
        (title: string = '') => {
            // 1.在正文将标题删除后保存，默认使用原标题。 2.在目录树将标题删除后失焦，使用默认标题(未命名文档)
            docTitle.current = title.trim() || curDocument?.name;
        },
        [curDocument?.name]
    );

    useEffect(() => {
        currentMode.current = mode;
    }, [mode]);

    // 检查是否需要自动转如流待办
    async function checkAutoTransOnlineTodo() {
        try {
            if (repository.external) {
                return;
            }
            return await editorRef.current?.autoTransOnlineTodo();
            // toto转换成功的时候result是undefined，失败的时候result是失败条数
        } catch (e) {
            // 不管是否出现异常，都不影响后续页面编辑状态变更流程，所以需要catch
            console.log(e);
        }
    }

    // 自动转如流待办结果处理（是否转换失败）
    function autoTransOnlineTodoResult(count?: number | void) {
        if (!window.isTocPage && count) {
            setTimeout(() => {
                toast({
                    type: ToastType.Error,
                    content: `有${count}条待办同步失败`,
                    duration: 3000,
                });
            }, 2000);
        }
    }

    // 开启会议模式
    const handleStartMeetingMode = useCallback(async () => {
        const todoTransRes =
            mode === EDITOR_MODE.edit
                ? await checkAutoTransOnlineTodo()
                : undefined;
        try {
            const ksServer = await sdk.getKsServer(repository);
            await ksServer.startDocumentMeeting(docGuid);
            toast({
                type: ToastType.Success,
                content: (
                    <span>
                        {intl.formatMessage({id: 'toastStartMeetingSuccess'})}
                    </span>
                ),
            });
            // 这里不变更模式，所有模式变更都依赖RTE通知
            closeSidebarWithNoStorage();

            // 上报埋点
            reportStartMeetingBtn({
                page_id: docGuid,
                user_id: sdk.as.user?.userGuid,
            });
        } catch {
            toast({
                type: ToastType.Error,
                content: intl.formatMessage({id: 'toastStartMeetingError'}),
            });
        }
        autoTransOnlineTodoResult(todoTransRes);
    }, [docGuid, intl, repository, mode]);

    useEffect(() => {
        // let oldReload: number;
        // let oldVersion: string | undefined;
        async function updateDocument() {
            if (!curDocument) {
                return;
            }
            // const oldDocument = prevCurDocument.current;
            // oldVersion = oldDocument?.docGuid === curDocument?.docGuid ? oldDocument?.version : '';
            const queryObj = getUrlParams();
            const {editor: queryEditor, isNewDoc} = queryObj!;
            const docGuid = curDocument?.docGuid;
            const state = history.location.state || {};
            const docIsCurUser =
                sdk.as.user?.userGuid === curDocument?.userGuid;
            const isNew = state.isNew || (isNewDoc && docIsCurUser);
            const isEdit = state.isEdit || isNewDoc;
            const isHistory = state.isHistory;
            const editable = docEditAble(repository, curDocument);
            if (curDocument?.isMeetingMode) {
                store.setDocumentMode(
                    isHistory ? EDITOR_MODE.history : EDITOR_MODE.meeting
                );
            } else if (isKuShareMode && isNew) {
                store.setDocumentMode(EDITOR_MODE.meeting);
                handleStartMeetingMode().then();
            } else if (queryEditor !== 'icafe_pattern') {
                if (isHistory) {
                    store.setDocumentMode(EDITOR_MODE.history);
                } else {
                    store.setDocumentMode(
                        isEdit && editable
                            ? EDITOR_MODE.edit
                            : EDITOR_MODE.preview
                    );
                }
            } else if (queryEditor === 'icafe_pattern') {
                store.setDocumentMode(EDITOR_MODE.edit);
            }
            setIsNew(!!isNew);
            setIsFirstPublish(!!isNew);
            isNewDocSceneObj.setVal(!!isNew || queryEditor === 'icafe_pattern');
            // 新增页面管理员可以编辑页面
            setEditable(editable);
            // const editor = editorRef.current;
            // let mentions: any = [];
            // let commentMentions: any = [];
            // try {
            //     mentions = editor ? editor.getMentionList() : [];
            //     commentMentions = editor ? editor.getCommentMentionList() : [];
            // } catch (err) {
            //     console.error(err);
            //     mentions = [];
            //     commentMentions = [];
            // }

            const newDoc: DocumentUpdateData = {
                action: DocumentOperateType.Publish,
                name: curDocument.name,
                mentions: [],
            };
            const ksServer = await sdk.getKsServer(repository);
            ksServer.updateDocumentOperate(newDoc, docGuid);
            updateDoTitle(curDocument.name);
            setDocumentTitle(curDocument.name, intl);
            store.setCurDocStar(null);
            store.setCurDocTag([]);
            store.setCurCommentCount({
                commentAllCount: curDocument.commentAllCount,
                underlineCommentCount: 0,
            });
        }

        // 如果是curDocument更新了再更新
        if (prevCurDocument.current?.docGuid !== curDocument?.docGuid) {
            updateDocument();
        }
        prevCurDocument.current = curDocument;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curDocument, history, intl, repository, updateDoTitle]);

    useEffect(() => {
        async function reloadDocument() {
            const {spaceGuid, groupGuid, repositoryGuid} = repository;
            if (!docGuid || !repository) {
                return;
            }
            const oldDocument = store.getData(store.KEYS.CUR_DOCUMENT);
            try {
                const isReload = true;
                await getDocumentInfo({
                    spaceGuid,
                    groupGuid,
                    repositoryGuid,
                    docGuid,
                });
                const oldVersion =
                    oldDocument?.docGuid === curDocument?.docGuid
                        ? oldDocument?.version
                        : '';
                const oldReload = reload;
                setReload(0);
                if (
                    oldReload === -1 &&
                    !loadingRef.current &&
                    curDocument?.version &&
                    oldVersion
                ) {
                    if (+oldVersion <= +curDocument?.version) {
                        toast({
                            type: ToastType.Success,
                            content: '刷新成功',
                            duration: 3000,
                        });
                    } else {
                        toast({
                            type: ToastType.Error,
                            duration: -1,
                            content: (
                                <span>
                                    刷新失败，
                                    <a onClick={handleClickRefresh}>点击重试</a>
                                </span>
                            ),
                            id: UPDATE_FAILED,
                        });
                    }
                }
            } catch (error) {
                store.setCurDocumentError(error);
            }
        }

        if (reload && prevReload.current !== reload) {
            reloadDocument();
            // feLogger(openPageUrl({
            //     pageId: curDocument?.docGuid,
            //     repoId: repository.repositoryGuid,
            //     groupId: repository.groupGuid,
            // }));
        }
        prevReload.current = reload;
    }, [reload, curDocument, handleClickRefresh, repository, history, docGuid]);

    useEffect(() => {
        if (curDocumentError && curDocumentError.code) {
            setError(curDocumentError);
            store.setCurDocument(null);
            if (curDocumentError.code === ErrorCode.NoPermission) {
                perfLogger.docPagePaint.paintStop();
            }
        }
        if (!curDocumentError) {
            setError(null);
        }
    }, [curDocumentError, history]);

    useEffect(() => {
        if (
            demoMode ||
            previousModeRef.current === mode ||
            !previousModeRef.current ||
            // 解决加载后直接进入编辑状态的页面 重复上报开始埋点问题
            isGettingDocData.current
        ) {
            previousModeRef.current = mode;
            return;
        }
        const currentMode = previousModeRef.current as any;
        perfLogger.editorPaint.paintStart(
            currentMode,
            mode as any,
            LOG_DOC_TYPE.doc
        );
        previousModeRef.current = mode;
    }, [demoMode, mode]);

    // eslint-disable-next-line complexity
    useEffect(() => {
        if (curDocument?.docGuid) {
            const storageHaveUnPublishName = `${curDocument?.docGuid}${sdk.as.user?.userGuid}`;
            const storageHaveUnPublish = storageUtils.get(
                storageHaveUnPublishName
            );
            const haveCurUser =
                unPublishData?.updateMembers &&
                unPublishData?.updateMembers.some((data: string) => {
                    return data === sdk.as.user?.userGuid;
                });
            if (
                curDocument?.docGuid === unPublishData.docGuid &&
                haveCurUser &&
                (!storageHaveUnPublish ||
                    (storageHaveUnPublish &&
                        storageHaveUnPublish.latestVersionId !==
                        unPublishData.latestVersionId))
            ) {
                setShowUnPublishTip(true);
                unPublishData.latestVersionId &&
                    storageUtils.set(storageHaveUnPublishName, unPublishData);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unPublishData]);

    useEffect(() => {
        if (!curDocument) {
            return;
        }

        setShowUnPublishTip(false);
        const newVersionInfo = store.getCurNewVersionInfo();
        if (newVersionInfo.docGuid !== curDocument?.docGuid) {
            store.setCurNewVersionInfo({
                ...newVersionInfo,
                docGuid: '',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curDocument, docGuid, reload]);

    useEffect(() => {
        if (mode === EDITOR_MODE.edit) {
            const newVersionInfo = store.getCurNewVersionInfo();
            store.setCurNewVersionInfo({
                ...newVersionInfo,
                docGuid: '',
            });
            setShowUnPublishTip(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    useEffect(() => {
        store.setDocSaveStatus(RTE_STATUS.init);
    }, [docGuid, mode]);

    // 点击了解更多
    const handleLearnMore = () => {
        const docUrl = 'https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/munIPCvcFy/NECA0XY_1Per5_';
        window.open(docUrl, '_blank');
    };

    const handlePublish = useCallback(async () => {
        if (isPublishLoading) {
            return;
        }
        const documentTitle = docTitle.current;
        if (!documentTitle) {
            toast({
                type: ToastType.Error,
                content: '请输入标题',
            });
            return;
        }
        const editor = editorRef.current;

        // 如果有@人通知待处理，则先处理完通知
        closeAllToastAndResolve();
        await getNotifyPromiseAll();

        const isCardView = store.getData(store.KEYS.IS_CARD_VIEW);
        const docVersion = store.getData(store.KEYS.CUR_DOCUMENT).version;
        // 判断是首次发布
        const isFirstPublish = docVersion === '1';
        // 视图是否被切换过
        const isViewModified = store.getData(store.KEYS.IS_VIEW_MODIFIED);
        perfLogger.publish.publish(isCardView);
        setIsPublishLoading(true);
        const todoTransRes = await checkAutoTransOnlineTodo();
        let incrementMentionUserList: any[] = [];
        if ((window as any).isSdkPage) {
            incrementMentionUserList = editor ? getIncrementMentionUserList(editor) : [];
        }
        try {
            assert(curDocument);
            assert(curDocument.docGuid);
            // await isRTESaved();
            await editor?.isRTESaved(10 * 1000);
            const ksServer = await sdk.getKsServer(repository);
            // const newDoc: DocumentUpdateData = {
            //     action: DocumentOperateType.Publish,
            //     name: documentTitle,
            // };
            // editor && editor.uploadPendingOps();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            // await ksServer.updateDocument(curDocument.docGuid, newDoc);
            const wordCount = store.getDocWordNum().totalWordCount || 0;
            // MARKS: action = publish改为单独接口
            const res = await ksServer?.publishDocument(docGuid, documentTitle, isCardView, isFirstPublish, isViewModified, wordCount);
            const {autoTransCardView} = res;

            kuToolEvent.emit(EventKeys.NEW_VERSION, {
                info: '有新版本发布',
                data: {
                    version: res?.version,
                },
            });

            // 清理锚点
            window.location.hash = '';
            try {
                perfLogger.publish.onlyPublishSuccess();
                setDocumentScrollPosition();
                handleBackPreview();
            } catch (error) {
                console.error(error);
            }
            const publishToSquareData = store.getData(
                store.KEYS.PUBLISH_TO_SQUARE_DATA
            );
            const autoTransCardViewNum = localStorage.getItem('autoTransCardViewNum') || 0;

            if (autoTransCardView && Number(autoTransCardViewNum) < 3) {
                // 弹出自动转换提示，且前三次才弹出
                toast({
                    type: ToastType.Success,
                    content: (
                        <div className={styles.autoTransTipWrap}>
                            <div>发布成功，已自动升级为卡片视图</div>
                            <div
                                className={styles.autoTransTip}
                                onClick={handleLearnMore}
                            >点击了解更多</div>
                        </div>),
                    duration: 3000,
                });
                localStorage.setItem('autoTransCardViewNum', (Number(autoTransCardViewNum) + 1).toString());
            } else {
                toast({
                    type: ToastType.Success,
                    content: intl.formatMessage({
                        id: getPublishSuccessToast(publishToSquareData),
                    }),
                });
            }
            autoTransOnlineTodoResult(todoTransRes);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            const doc = await ksServer.getDocumentInfo(docGuid);
            store.setCurDocument({...curDocument, ...doc});
            updateHistoryState(history, {
                isEdit: false,
                isNew: false,
            });
            setDocumentTitle(documentTitle, intl);
            setEditable(true);
            setIsPublishLoading(false);
            perfLogger.publish.publishSuccess(isCardView);
            if ((window as any).isSdkPage) {
                kuSdkEvent.emitPublishEnd({
                    code: 200,
                    version: res.version,
                    mentions: incrementMentionUserList,
                });
            }

            if (docGuid) {
                clearTimeout(timer);
                timer = setTimeout(async () => {
                    // 发布埋点
                    const tags = (await getTagList()) || [];
                    const tagSlice = tags.slice(0, 10);
                    const tagContent = tags
                        ? tagSlice
                            .map((item: TagData) => {
                                return item.name;
                            })
                            .join(',')
                        : '';
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    const sNumber =
                        tags.filter((item: TagData) => item.tagType === 1)
                            .length + '' || '';
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    const sNumberShow =
                        tagSlice.filter((item: TagData) => item.tagType === 1)
                            .length + '' || '';
                    const showTagNum = `${tagSlice.length}`;
                    const creatTime = curDocument?.created || 0;
                    const isEmpty = !!editorRef.current?.isEmptyDocument();
                    feLogger(
                        publish({
                            groupId: repository.groupGuid,
                            repoId: repository.repositoryGuid,
                            pageId: curDocument.docGuid,
                            sNumber,
                            sNumberShow,
                            tagContent,
                            showTagNum,
                            creatTime,
                            isEmpty,
                        })
                    );
                }, 1000);
            }

            // 清理提及文档的摘要数据缓存
            resetDocSummaryCache();

            kuJSSDKEventBus.emit(DOC_PUBLISH, {
                url: window.location.href,
                spaceGuid: curDocument.spaceGuid,
                groupGuid: curDocument.groupGuid,
                repositoryGuid: curDocument.repositoryGuid,
                docGuid,
                name: doc.name,
                version: doc.version,
            });
        } catch (error) {
            console.error(error);
            perfLogger.publish.publishError(LOG_DOC_TYPE.doc, error as Error);
            setIsPublishLoading(false);
            setEditable(true);
            if (error instanceof WizKnownError) {
                if ((window as any).isSdkPage) {
                    kuSdkEvent.emitPublishEnd({
                        code: error.toResult().returnCode,
                    });
                }
                if (error.toResult().returnCode === 600) {
                    toast({
                        type: ToastType.Error,
                        content: '已存在同名页面，同一空间各页面标题必须唯一',
                    });
                    return;
                    // editor && editor.selectTitle(); // 跟RTE沟通selectTitle是个空函数并且在2.0版本去掉了
                }
                if (error.toResult().returnCode === 403) {
                    toast({
                        type: ToastType.Error,
                        content: '暂无操作权限',
                    });
                    return;
                }
                if (error.toResult().returnCode === 404) {
                    toast({
                        type: ToastType.Error,
                        content: '此页面已被其他人删除',
                    });
                    return;
                }
            }
            if ((window as any).isSdkPage) {
                kuSdkEvent.emitPublishEnd({
                    code: 500,
                });
            }
            toast({
                type: ToastType.Error,
                content: '发布失败',
            });
            autoTransOnlineTodoResult(todoTransRes);
        }
    }, [
        curDocument,
        docGuid,
        getTagList,
        handleBackPreview,
        history,
        intl,
        repository,
        setDocumentScrollPosition,
        isPublishLoading,
    ]);

    useEffect(() => {
        if ((window as any).isSdkPage) {
            kuSdkEvent.onPublish(handlePublish);
        }
        return () => {
            if ((window as any).isSdkPage) {
                kuSdkEvent.offPublish();
            }
        };
    }, [handlePublish]);

    const scrollToUserAnchorPosition = useCallback(
        (userId: string): boolean => {
            const editor = editorRef.current;
            const isAnchorActive =
                (editor as any)?.scrollToView(userId) || false;
            return isAnchorActive;
        },
        []
    );

    const handleChangeEdit = useCallback(() => {
        handleSwitchEdit();

        setDocumentScrollPosition();

        // 清理提及文档的摘要数据缓存
        resetDocSummaryCache();

        const isCardView = store.getData(store.KEYS.IS_CARD_VIEW);
        // 编辑按钮埋点
        feLogger(
            pageEdit({
                groupId: repository.groupGuid,
                repoId: repository.repositoryGuid,
                pageId: curDocument ? curDocument.docGuid : '',
                viewType: isCardView ? 'card' : 'doc',
            })
        );
        if (repository?.external) {
            if (window.isTocPage) {
                feLogger(clickUserEditor({
                    type: curDocument.type,
                }));
            } else {
                feLogger(clickExternalUserEditor({
                    type: curDocument.type,
                }));
            }
        }
    }, [curDocument,
        handleSwitchEdit,
        repository.external,
        repository.groupGuid,
        repository.repositoryGuid,
        setDocumentScrollPosition]);

    // 结束会议模式
    const handleStopMeeting = useCallback(async () => {
        const documentTitle = docTitle.current;
        if (!documentTitle) {
            toast({
                type: ToastType.Error,
                content: '请输入标题',
            });
            return;
        }
        try {
            const isCardView = store.getData(store.KEYS.IS_CARD_VIEW);
            const docVersion = store.getData(store.KEYS.CUR_DOCUMENT).version;
            // 判断是首次发布
            const isFirstPublish = docVersion === '1';
            // 视图是否被切换过
            const isViewModified = store.getData(store.KEYS.IS_VIEW_MODIFIED);

            const ksServer = await sdk.getKsServer(repository);
            const newDoc: DocumentUpdateData = {
                action: DocumentOperateType.Publish,
                name: documentTitle,
                mentions: [],
                isCardView: isCardView ? 1 : 0,
                isFirstPublish: isFirstPublish ? 1 : 0,
                isViewModified: isViewModified ? 1 : 0,
                wordCount: store.getDocWordNum().totalWordCount || 0,
            };

            const res = await ksServer.stopDocumentMeeting(docGuid, newDoc);
            const {autoTransCardView} = res;

            // 清理锚点
            window.location.hash = '';
            // 重置isMeeting
            updateHistoryState(history, {
                isMeeting: false,
            });
            const autoTransCardViewNum = localStorage.getItem('autoTransCardViewNum') || 0;

            if (autoTransCardView && Number(autoTransCardViewNum) < 3) {
                // 弹出自动转换提示，且前三次才弹出
                toast({
                    type: ToastType.Success,
                    content: (
                        <div className={styles.autoTransTipWrap}>
                            <div>协作模式结束成功，已自动升级为卡片视图</div>
                            <div
                                className={styles.autoTransTip}
                                onClick={handleLearnMore}
                            >点击了解更多</div>
                        </div>),
                    duration: 3000,
                });
                localStorage.setItem('autoTransCardViewNum', (Number(autoTransCardViewNum) + 1).toString());
            } else {
                toast({
                    type: ToastType.Success,
                    content: (
                        <span>
                            {intl.formatMessage({id: 'toastStopMeetingSuccess'})}
                        </span>
                    ),
                });
            }

            // 上报埋点
            reportStopMeetingBtn({
                page_id: docGuid,
                user_id: sdk.as.user?.userGuid,
                type: 0, // 手动关闭 0, 自动关闭 1
            });
        } catch {
            toast({
                type: ToastType.Error,
                content: intl.formatMessage({id: 'toastStopMeetingError'}),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid, intl, repository]);

    // 处理会议过程中权限移除
    function handleRemovePermission() {
        setEditable(false);
        setShowChangePermissionDialog(true);
    }

    // 处理会议过程中页面权限变更
    function handleChangePermission(data: IPermissionChange, isRepo: boolean) {
        const {userOldPermission, userNewPermission} = data.data?.value || {};
        const preCanEdit = isRepo
            ? userOldPermission === Role.Admin ||
            userOldPermission === Role.Member
            : userOldPermission === DocRole.DocAdmin ||
            userOldPermission === DocRole.Member;
        const nowPageOnlyRead = isRepo
            ? userNewPermission === Role.Reader
            : userNewPermission === DocRole.Reader;

        const isPagePermissionDegrade = preCanEdit && nowPageOnlyRead; // 权限从编辑降为可读
        if (isPagePermissionDegrade) {
            setEditable(false);
            setShowChangePermissionDialog(true);
        }
    }

    // 处理会议过程中知识库公开设置变更
    function handleChangeRepoPublic(data: IRepoPublicChange) {
        const {preRepoPublic, repoPublic} = data.data?.value || {};
        if (preRepoPublic === true && repoPublic === false) {
            setEditable(false);
            setShowChangePermissionDialog(true);
        }
    }

    // 5s后自动关闭
    const delayCloseTipAlert = useMemo(() => {
        return debounce(() => setShowMeetingTipAlert(false), 5000);
    }, []);

    const mentionNotifyOfComment = useMentionNotifyOfComment(
        mode,
        repository,
        docGuid
    );
    const handleAddCommentMentions = useCallback(
        (data: ICommentMentionNotify) => {
            const {mentionList = [], commentId} = data.data || {};
            mentionList.forEach((item) => {
                mentionCache.setCommentId(item.uuid, commentId);
            });

            mentionNotifyOfComment(data);
        },
        [mentionNotifyOfComment]
    );

    const {handleStartMeetingNotify, handleStopMeetingNotify} = useMemo(() => {
        return {
            // 处理开启会议的通知
            handleStartMeetingNotify(data: IMeetingNotify) {
                const meetingInfo = getMeetingInfo(data);
                setMeetingInfo(meetingInfo);
                getDocsInMeeting();
                setDocumentScrollPosition();

                if (!showOpenTip(meetingInfo)) {
                    handleSwitchMeeting();
                    return;
                }

                if (mode === EDITOR_MODE.preview) {
                    console.log(
                        '测试：协作模式接收到开启通知------------------------'
                    );
                    // 用户是否在评论框内
                    const userIsEditing =
                        document.activeElement &&
                        document.activeElement.classList.contains(
                            'mp-micro-editor'
                        ) &&
                        document.activeElement.getAttribute(
                            'contenteditable'
                        ) === 'true';

                    // 底部评论和划线评论是否有未保存内容
                    const haveText = Array.from(
                        document.querySelectorAll('.mp-micro-editor')
                    ).some((node: Element) => {
                        return !!(
                            (node as HTMLDivElement).innerText &&
                            (node as HTMLDivElement).innerText.trim()
                        );
                    });

                    // 如果用户正在评论或者划线评论则采用toast的方式提示用户开启协作模式
                    // 如果用不是正在评论则使用阻断式弹窗提示用户进入协作模式
                    // 评论框里有内容的时候也是toast提示
                    if (userIsEditing || haveText) {
                        toast({
                            content: (
                                <span>
                                    当前页面已启动协作模式，请在评论完成后
                                    <a
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowStartMeetingDialog(false);
                                            window.location.reload(); // 直接刷新页面，兼容会议结束后才点击确定的情况
                                        }}
                                    >
                                        刷新
                                    </a>
                                    页面。
                                </span>
                            ),
                            type: ToastType.Warning,
                            duration: -1,
                        });
                        return;
                    }
                    setShowStartMeetingDialog(true);
                } else if (mode === EDITOR_MODE.edit) {
                    setShowMeetingTipAlert(true);
                    delayCloseTipAlert();
                    handleSwitchMeeting();
                }
            },

            // 处理结束会议的通知
            async handleStopMeetingNotify(data: IMeetingNotify) {
                const meetingInfo = getMeetingInfo(data);
                getDocsInMeeting();
                syncSidebarStatusFromStorage(); // 结束会议时所有人都同步侧边栏的缓存(一般只有会议发起者的展示可能跟缓存不一致)
                setDocumentScrollPosition();

                // 同步文档信息
                const newDoc: DocumentUpdateData = {
                    action: DocumentOperateType.Publish,
                    name: docTitle.current,
                };
                const ksServer = await sdk.getKsServer(repository);
                ksServer.updateDocumentOperate(newDoc, docGuid);
                const doc = await ksServer.getDocumentInfo(docGuid);
                store.setCurDocument({...curDocument, ...doc});
                getTagList();

                if (!showCloseTip(meetingInfo)) {
                    handleBackPreview();
                    return;
                }

                const isUserRefer =
                    meetingInfo.refer === endMeetingNotifyRefer.USER;
                const toastTip = isUserRefer
                    ? `${meetingInfo.creatorUser.name}结束了协作`
                    : '协作模式已结束';
                toast({
                    type: ToastType.Normal,
                    content: toastTip,
                });
                handleBackPreview();
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        delayCloseTipAlert,
        handleSwitchMeeting,
        mode,
        docGuid,
        handleBackPreview,
        curDocument,
    ]);

    const handleModeChange = useCallback((toMode: EDITOR_MODE) => {
        store.setDocumentMode(toMode);
    }, []);

    const handleCollaboratorChange = useCallback(
        ({data: {collaborators}}: ICollaboratorChange) => {
            // setCollaborations(collaborators);
            store.setCurCollaborators(collaborators);
        },
        []
    );

    const handleEditorFirstChange = useCallback(() => {
        setIsNew(false);
        updateHistoryState(history, {
            isNew: false,
        });
        feLogger(
            editDocFirstLog({
                pageId: curDocument ? curDocument.docGuid : '',
                creatTime: curDocument?.created || 0,
            })
        );
    }, [history, curDocument]);

    const handleModeChangeNotify = useCallback(() => {
        if (mode === EDITOR_MODE.history) {
            const {isEdit, isMeeting} = history.location.state || {};
            updateHistoryState(history, {
                isHistory: false,
            });
            const mode = isMeeting
                ? EDITOR_MODE.meeting
                : isEdit
                    ? EDITOR_MODE.edit
                    : EDITOR_MODE.preview;
            handleModeChange && handleModeChange(mode);
        }
    }, [mode, handleModeChange, history]);

    const handlePublishSuccessNotify = useCallback(
        (data: IPublishSuccessInfo) => {
            const {
                versionInfo: {updateMembers},
            } = data.data;
            store.setCurNewVersionInfo({
                docGuid,
                uids: updateMembers,
                reload: +new Date(),
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [docGuid]
    );

    const handlePublishDraftNotify = useCallback((data: IPublishDraftInfo) => {
        const {
            latestVersionInfo: {updateMembers},
            latestVersionId,
        } = data.data;
        setUnPublishData({
            docGuid: docGuid,
            uid: sdk.as.user?.userGuid,
            updateMembers,
            latestVersionId,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRevertSuccess = useCallback(
        async ({data: {title}}: IRevertNotify) => {
            assert(curDocument);
            assert(curDocument?.docGuid);
            if (!title) {
                return;
            }
            const ksServer = await sdk.getKsServer(repository);
            // const newDoc: DocumentUpdateData = {
            //     action: DocumentOperateType.Rename,
            //     name: title,
            // };
            // // eslint-disable-next-line @typescript-eslint/no-floating-promises
            // const doc = await ksServer.updateDocument(curDocument.docGuid, newDoc);

            // MARKS: action = rename改为单独接口
            const doc = await ksServer.renameDocument(
                curDocument.docGuid,
                title
            );
            store.setCurDocument({
                ...curDocument,
                ...doc,
            });
            store.setDocumentPosition(null); // // 恢复历史版本，清除原版本的滚动位置
            handleBackPreview();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [curDocument, handleBackPreview, repository]
    );

    const handleSave = useCallback(
        ({action}: INotify) => {
            saveDebounce(action, () => {
                store.setDocSaveStatus(action);
            });

            if (action === rteNotifyPublishTypeAction.SUCCESS) {
                triggerRecommendTitle();
            }
        },
        [triggerRecommendTitle]
    );

    const [titleNode, setTitleNode] = useState<any>({});

    const handleSetTitleNode = useCallback(() => {
        setTimeout(() => {
            const editor = editorRef.current;
            if (editor && editor.getDocNode) {
                setTitleNode(editor.getDocNode()[0] || {});
            }
        }, 50);
    }, []);

    const handleChange = useCallback(() => {
        // 文档内容变更
        handleSetTitleNode();
    }, [handleSetTitleNode]);

    const updateUnderLineCommentCount = useCallback((domTree, commentObj) => {
        const count = getUnderLineCommentCount(domTree, commentObj);
        const commentCount = store.getCurCommentCount();
        store.setCurCommentCount({
            ...commentCount,
            underlineCommentCount: count,
        });
    }, []);

    const getFollowedInfo = useCallback(async () => {
        if (window.isTocPage) {
            return;
        }
        const {spaceGuid, groupGuid, repositoryGuid} = repository;
        // const info = await sdk.as.hasFollowedDoc(repository.spaceGuid, repository.repositoryGuid, docGuid);
        const info = await sdk.as.hasFollowStar({
            type: FOLLOW_TYPE.doc,
            spaceGuid,
            groupGuid,
            repositoryGuid,
            docGuid,
        });
        if (info?.followGuid) {
            store.setCurDocStar(info.followGuid);
        } else {
            store.setCurDocStar(null);
        }
    }, [repository, docGuid]);

    const handleTitleChange = useCallback(
        (data: IDocChangeNotify) => {
            // 加上setTimeout，避免多人同时修改标题导致的更新不一致
            setTimeout(async () => {
                const doc = data?.data?.value?.doc;
                updateDoTitle(doc.name);

                // 同步到文档标题
                store.setCurDocument({...store.getCurDocument()!, ...doc});
                // 同步到侧边栏标题
                const updateData: DocumentUpdateData = {
                    action: DocumentOperateType.Rename,
                    name: doc.name,
                };
                const ksServer = await sdk.getKsServer(repository);
                ksServer.updateDocumentOperate(updateData, docGuid);
            }, 0);
        },
        [docGuid, repository, updateDoTitle]
    );

    const handleUnderLineCommentSendMsg = useCallback(
        async (data: IUnderlineCommentNotice) => {
            // 如果是sdk文档视图页面，不发送消息
            if (getIsSdkPage()) {
                return;
            }
            let modeParams = '';
            if (EDITOR_MODE.edit === mode) {
                modeParams = EDITOR_MODE.edit;
            }
            if ([EDITOR_MODE.preview, EDITOR_MODE.meeting].includes(mode)) {
                modeParams = 'read';
            }
            const ksServer = await sdk.getKsServer(repository);
            ksServer.underLineCommentSendMsg(docGuid, {
                ...data,
                mode: modeParams,
            });
        },
        [docGuid, repository, mode]
    );

    // 中间件开放 hook - 文档渲染前调用（临时方案）
    useEffect(() => {
        kuPiper.runHook(kuPiper.hookNameMap.BeforeDocRenderHook, {});
    }, []);

    // 中间件开放hook
    const callAfterDocRenderHook = useCallback(() => {
        kuPiper.runHook(kuPiper.hookNameMap.AfterDocRenderHook, {
            // docInfo: {
            //     canEdit,
            //     canRead,
            // },
        });
    }, []);

    const getDownloadMessage = useCallback(
        async (
            repositoryGuid: string,
            docGuid: string,
            fileGuid: string,
            fileName: string
        ) => {
            try {
                const ksServer = await sdk.getKsServer(repository);
                const res = ksServer.getDownloadRecord(
                    repositoryGuid,
                    docGuid,
                    fileGuid,
                    fileName
                );
                console.info('getDownloadMessage:', res);
            } catch (error) {
                console.log('error:', error);
            }
        },
        [repository]
    );

    // 处理websocket连接状态变化
    function handleWebsocketStatus(action: string, data: any) {
        if (!data) {
            return;
        }
        const {isBackupUrl, retryCount, errLogId} = data;
        if (action === rteNotifyWsAction.fail) {
            store.setDocWsStatus('wsOffline');
            console.log(
                '日志：ws--fail-------',
                retryCount,
                isBackupUrl,
                errLogId,
                wsBackupFirstErrLog
            );
            if (retryCount === 1) {
                reportRteEvent(EventNameMap.wsFail, data, 'click', true);
            }
            if (wsBackupFirstErrLog !== 0) {
                wsBackupFirstErrLog = errLogId;
            }
            if (isBackupUrl) {
                if (retryCount && retryCount % WsRetryCountLogMax === 0) {
                    // ws备用地址重连失败，每n次上报一次埋点
                    reportRteEvent(
                        EventNameMap.wsBackupMaxFail,
                        data,
                        'click',
                        true
                    );
                }
                if (retryCount === WsRetryCountLogMax && isInKuShare()) {
                    toast({
                        type: ToastType.Error,
                        content: '网络异常，请刷新页面或重启客户端',
                        duration: 0,
                    });
                }
            }
        } else if (action === rteNotifyWsAction.success) {
            store.setDocWsStatus('wsOnline');
            console.log(
                '日志：ws--success-------',
                retryCount,
                isBackupUrl,
                errLogId,
                wsBackupFirstErrLog
            );
            if (isBackupUrl && errLogId && errLogId === wsBackupFirstErrLog) {
                // 仅上报更换备用地址后第1次成功，后续再断开重连不再上报
                reportRteEvent(
                    EventNameMap.wsBackupFirstSuccess,
                    data,
                    'click',
                    true
                );
                wsBackupFirstErrLog = 0; // wsBackupFirstErrLog置为0，代表已连接成功，使用过一次后此flag不再使用
            }
            if (
                isBackupUrl &&
                retryCount >= WsRetryCountLogMax &&
                isInKuShare()
            ) {
                toastObjects[ToastType.Error]?.remove();
                toast({
                    type: ToastType.Success,
                    content: 'Ku享连接成功',
                    duration: 2000,
                });
            }
        }
    }

    const handleNotifyOfAgent = useAIAgent(docGuid, mode, editable);

    // 处理RTE的通知
    const handleRteNotify = useCallback(
        async (data: INotify) => {
            // 线上问题判断依据 请兄弟姐妹们一定不要删Thanks♪(･ω･)ﾉ
            console.info('收到RTE通知，数据是:', data); // 用于调试
            const {type, action} = data;

            if (type === rteNotifyType.AIGC_PLUGIN_MESSAGE_CHANGE) {
                handleNotifyOfAgent(data);
            }

            if (type === rteNotifyType.PUBLISH) {
                switch (action) {
                    case rteNotifyPublishTypeAction.START_MEETING:
                        handleStartMeetingNotify(data as IMeetingNotify);
                        break;
                    case rteNotifyPublishTypeAction.END_MEETING:
                        handleStopMeetingNotify(data as IMeetingNotify);
                        break;
                    case rteNotifyPublishTypeAction.SUCCESS:
                        handlePublishSuccessNotify(data as IPublishSuccessInfo);
                        break;
                    case rteNotifyPublishTypeAction.PUBLISH_DRAFT:
                        handlePublishDraftNotify(data as IPublishDraftInfo);
                        break;
                    default:
                        console.info('RTE Notification  Untreated:', data);
                        break;
                }
            }

            if (type === rteNotifyType.MENTION) {
                const {
                    data: {mentionList = [], infoList = []},
                } = data as any;
                const mentionPeopleInUnderlineComment = mentionList.filter(
                    (item: any) => item.type !== 'doc'
                );
                const mentionPeopleInContent = infoList.filter(
                    (item: any) => item.type !== 'doc'
                );
                switch (action) {
                    case rteNotifyPublishTypeAction.COMMENT_SUBMIT:
                        handleAddCommentMentions(data as ICommentMentionNotify);
                        if (mentionPeopleInUnderlineComment.length > 0) {
                            feLogger(
                                mention({
                                    pageid: docGuid,
                                    type: modeType[mode],
                                    userid: sdk.as.user?.userGuid,
                                    receiver:
                                        mentionPeopleInUnderlineComment.map(
                                            (item: any) => item.uid
                                        ),
                                    source: MentionSource.underLineComment,
                                })
                            );
                        }
                        break;
                    case rteNotifyPublishTypeAction.MENTION_USER_IN_CONTENT:
                        if (mentionPeopleInContent.length > 0) {
                            feLogger(
                                mention({
                                    pageid: docGuid,
                                    type: modeType[mode],
                                    userid: sdk.as.user?.userGuid,
                                    receiver: mentionPeopleInContent.map(
                                        (item: any) => item.id
                                    ),
                                    source: MentionSource.content,
                                })
                            );
                        }
                        break;
                    default:
                        break;
                }
            }

            switch (type) {
                case rteNotifyBroadcastType.permission_remove:
                case rteNotifyBroadcastType.repo_permission_remove:
                    handleRemovePermission();
                    break;
                case rteNotifyBroadcastType.permission_change:
                    handleChangePermission(data as IPermissionChange, false);
                    break;
                case rteNotifyBroadcastType.repo_permission_change:
                    handleChangePermission(data as IPermissionChange, true);
                    break;
                case rteNotifyBroadcastType.repo_scope_change:
                    handleChangeRepoPublic(data as IRepoPublicChange);
                    break;
                default:
                    break;
            }

            if (type === rteNotifyBroadcastType.doc_update) {
                handleTitleChange(data as IDocChangeNotify);
            }
            if (type === rteNotifyBroadcastType.doc_delete) {
                const user = data.data?.value?.user;
                if (user && user.userGuid !== sdk.user?.userGuid) {
                    setShowDocDeleteDialog(true);
                }
            }

            if (type === rteNotifyType.REVERT) {
                switch (action) {
                    case rteNotifyPublishTypeAction.SUCCESS:
                        handleRevertSuccess(data as IRevertNotify);
                        break;
                    case rteNotifyPublishTypeAction.REVERT_BACK:
                        handleModeChangeNotify();
                        break;
                    default:
                        console.info('RTE Notification  Untreated:', data);
                        break;
                }
            }
            if (type === rteNotifyType.EDITOR) {
                // 评论信息变化
                if (data.action === rteNotifyPublishTypeAction.COMMENT_CHANGE) {
                    setTimeout(() => {
                        eventBus.emit(COMMENT_INFO_CHANGE, data.data);
                    }, 0);
                }
                // 评论列表变化
                if (data.action === rteNotifyPublishTypeAction.COMMENT_LIST_CHANGE) {
                    setTimeout(() => {
                        eventBus.emit(COMMENT_LIST_CHANGE, data.data);
                    }, 0);
                }
                if (data.action === rteNotifyPublishTypeAction.CHANGE_FIRST) {
                    handleEditorFirstChange();
                }
                if (data.action === rteNotifyPublishTypeAction.SETGAZE_CHANGE) {
                    setTimeout(() => {
                        const position = store.getData(
                            store.KEYS.DOCUMENT_POSITION
                        );
                        position && scrollToDocumentPrePosition();
                    }, 0);
                }
                if (data.action === rteNotifySlideAction.SLIDE_SHOWGUIDE) {
                    setShowCardViewGuide(true);
                }
                if (data.action === rteNotifySlideAction.SLIDE_INIT) {
                    if (data.data?.slide) {
                        store.setIsCardView(true);
                        const htmljson = editorRef.current?.morphoServices(
                            serviceNames.IEditorStateService
                        ).editor.children;
                        const cardNum = htmljson.filter(
                            (item: any) => item.type === 'card'
                        ).length;
                        docCardViewBuriedObj.report(docGuid, cardNum);
                    } else {
                        store.setIsCardView(false);
                    }

                    const isNewScene = isNewDocSceneObj.getVal();
                    if (isNewScene) {
                        feLogger(
                            createNewDocView({
                                type: data.data?.slide ? 'card' : 'doc',
                                docId: docGuid || '',
                            })
                        );
                    }
                    store.setIsShowCover(data.data?.showCover);
                    store.setShowDocCover(!!data.data?.showDocCover);
                    store.setShowSlideCover(!!data.data?.showSlideCover);
                }
                if (data.action === rteNotifySlideAction.SLIDE_CHANGE) {
                    store.setIsCardView(!!data.data?.slide);
                }
                if (data.action === rteNotifyCoverAction.COVER_CHANGE) {
                    // store.setIsShowCover(!!data.data?.showCover);
                    store.setShowDocCover(!!data.data?.showDocCover);
                    store.setShowSlideCover(!!data.data?.showSlideCover);
                }
                if (data.action === rteNotifyCoverAction.COVER_APPLY) {
                    store.setIsCoverApplied(!!data.data?.isCoverApplied);
                }
                if (data.action === rteNotifyPrintAction.PRINT) {
                    handleDocPrint(isPreviewMode);
                }
                // 收到通知后页面需要重新加载
                if (data.action === rteNotifyCommentAction.SAVECOMMENT_RELOAD) {
                    store.setSaveCommentReload(true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            }
            if (type === rteNotifyType.SAVE) {
                handleSave(data);
            }
            if (type === rteNotifyType.COLLABORATOR) {
                if (data.action === rteNotifyCollaboratorAction.CHANGE) {
                    handleCollaboratorChange(data as ICollaboratorChange);
                } else if (
                    data.action === rteNotifyCollaboratorAction.SAVE_SUCCESS
                ) {
                    store.setLatestEditUser(
                        (data as ICollaboratorSaveSuccess).data
                    );
                }
            }
            // if (
            //     type === rteNotifyType.INIT
            //     && data.action === rteNotifyInitAction.START
            // ) {
            //     linkingReset();
            // }
            if (
                type === rteNotifyType.INIT &&
                data.action === rteNotifyInitAction.END
            ) {
                setTimeout(() => {
                    const mode = (data as IInitNotify).data?.mode;
                    perfLogger.editorPaint.paintEnd({
                        currentMode: mode as CategoryType,
                        docType: LOG_DOC_TYPE.doc,
                    });
                    const paintEndData = perfLogger.docPagePaint.paintEnd(
                        DOC_END_TYPE.rte,
                        docGuid,
                        {
                            docType: LOG_DOC_TYPE.doc,
                        }
                    );
                    perfLogger.loadTimeDetailed.save(
                        perfLogger.loadTimeDetailed.const.DELAY,
                        paintEndData.delay
                    );
                    perfLogger.compRender.takeSnapshot();
                }, 0);
                // 更新关注
                setTimeout(async () => {
                    getFollowedInfo();
                    getTagList();
                    store.setShowEditorChildren(true);
                    scrollToDocumentPrePosition();
                    // 文档页面 编辑器部分加载后 清理token老旧数据
                }, 0);

                showCompatibilityTips(editorRef.current);
                callAfterDocRenderHook();
                // 页面初始化完成
                eventBus.emit(DOCUMENT_INIT_COMPLETE);
            }
            if (
                type === rteNotifyType.INIT &&
                data.action === rteNotifyInitAction.DOC_END
            ) {
                domReadyTimer && clearTimeout(domReadyTimer);
                store.setDocReady(true);
                perfLogger.loadTimeDetailed.save(
                    perfLogger.loadTimeDetailed.const.RTE_DOM_START_TIME,
                    performance.now()
                );

                const docTitle =
                    data.data.editorValue && data.data.editorValue[0];
                // 处理标题节点，如果data内没有节点，执行handleSetTitleNode设置;
                if (docTitle.type === 'title') {
                    setTitleNode(docTitle);
                } else {
                    handleSetTitleNode();
                }
                // 预加载 hover 引用文档卡片组件
                preloadSummaryCard();
            }
            if (type === rteNotifyType.DOM) {
                if (data.action === rteNotifyDomAction.DOM_READY) {
                    if (mode === EDITOR_MODE.preview) {
                        initCardMenuShow();
                    }
                    initFlowJS();
                    eventBus.emit(EDITOR_DOM_READY);
                    store.setEditorDomReady(true);
                    store.setIsEditorReloading(false);
                    setTimeout(() => {
                        perfLogger.docPagePaint.paintEnd(
                            DOC_END_TYPE.morphoPaint,
                            docGuid,
                            (data as IEditorNotify).data
                        );
                        perfLogger.loadTimeDetailed.log({
                            ...(data as IEditorNotify).data,
                        });
                    }, 0);

                    const isEdit = mode === EDITOR_MODE.meeting || mode === EDITOR_MODE.edit;
                    const dragService = getMorphoService(serviceNames.IDragCoreService);
                    isEdit && dragService.tapDragStart({
                        type: 'external',
                        accept: (el: HTMLElement) => {
                            return el.closest('.dragEvent');
                        },
                        getDataTransfer: (el: HTMLElement) => {
                            const data = MaterialMap.get(el);
                            return {
                                node: data.content[0],
                                source: data.dragImg,
                                materialOptions: {
                                    id: data.id,
                                    source: data.source,
                                    name: data.name,
                                },
                            };
                        },
                    });

                    return;
                }
                if (data.action === rteNotifyDomAction.FS_DOM_READY) {
                    eventBus.emit(EDITOR_FS_DOM_READY);

                    setTimeout(() => {
                        // eslint-disable-next-line no-underscore-dangle
                        const _data = (data as IEditorNotify).data;
                        const paintEndData = perfLogger.docPagePaint.paintEnd(
                            DOC_END_TYPE.morphoFsPaint,
                            docGuid,
                            _data
                        );
                        const logConst = perfLogger.loadTimeDetailed.const;
                        perfLogger.loadTimeDetailed.batchSave({
                            [logConst.FIRST_SHOWN_DELAY]: paintEndData.delay,
                            [logConst.LOAD_TYPE]: paintEndData.type,
                            [logConst.BROWSER_RENDER_TIME]: _data.browserRenderTime,
                            [logConst.DOM_BUILD_TIME]: _data.domBuildTime,
                            [logConst.WS_TIME]: _data.wsTime,
                            [logConst.NORMALIZING_TIME]: _data.normalizingTime,
                            [logConst.FS_NODES_COUNT]: _data.fsNodesCount,
                            [logConst.HAS_CARD_NODE]: _data.hasCardNode,
                            [logConst.DOC_MODE]: _data.docMode,
                        });
                    }, 0);
                }
            }
            if (type === rteNotifyType.PASTE) {
                rteWebLog({
                    id: '80001.8.51',
                    data: {
                        ...(data as IEditorNotify).data,
                        docType: LOG_DOC_TYPE.doc,
                    },
                });
            }
            if (type === rteNotifyType.COMMENT) {
                if (
                    [
                        rteNotifyCommentAction.CHANGE,
                        rteNotifyCommentAction.INIT,
                    ].includes(data.action)
                ) {
                    const {children, comments} = (data as any).data;
                    updateUnderLineCommentCount(children, comments);

                    if (data.action === rteNotifyCommentAction.INIT) {
                        store.setStatNumShow(true);
                    }
                }
                if (data.action === rteNotifyCommentAction.INIT) {
                    const comments = data.data.comments;
                    const queryObj = parse(window.location.search);
                    let rightCommentId: string = '';
                    if (isString(queryObj[KU_QUERY.document.rightCommentId])) {
                        rightCommentId = queryObj[KU_QUERY.document.rightCommentId] as string;
                    } else if (isArray(queryObj[KU_QUERY.document.rightCommentId])) {
                        rightCommentId = queryObj[KU_QUERY.document.rightCommentId]![0];
                    }

                    window.setTimeout(() => {
                        const removeKeys = [KU_QUERY.document.rightCommentId];
                        const rlNotice = queryObj[KU_QUERY.document.rlNotice] as string;
                        if (rightCommentId) {
                            removeKeys.push(KU_QUERY.document.block_id);
                        }
                        if (rlNotice) {
                            removeKeys.push(KU_QUERY.document.rlNotice);
                        }
                        removeSearchParamNoRefresh(removeKeys);
                    }, 2000);
                }
                if (data.action === rteNotifyCommentAction.START) {
                    perfLogger.underlineComment.start({
                        ...(data as IEditorNotify).data,
                        wikiMode: modeType[mode],
                        page_id: docGuid || '',
                        kb_id: repositoryGuid || '',
                        kb_org_id: groupGuid || '',
                    });
                }
                if (data.action === rteNotifyCommentAction.SUCCESS) {
                    perfLogger.underlineComment.success({
                        ...(data as IEditorNotify).data,
                        wikiMode: modeType[mode],
                    });
                }
                if (data.action === rteNotifyCommentAction.FAIL) {
                    perfLogger.underlineComment.error({
                        ...data.data,
                        wikiMode: modeType[mode],
                    });
                }
                if (data.action === rteNotifyCommentAction.ANCHOR_COMMENT_ADD) {
                    // Note: ws 下发成功。ws 下发会分很多 case 如评论删除修改等，此处仅上报锚点评论新增下发的 ws
                    perfLogger.underlineComment.wsSuccess({
                        wikiMode: modeType[mode],
                        commentId: data?.data?.comment?.commentId,
                        createTime: data?.data?.comment?.createdAt,
                        quote: data?.data?.comment?.quote,
                    });
                    // 新增评论
                }
                if (data.action === rteNotifyCommentAction.COMMENT_REPLY) {
                    // 评论回复
                }
                if (data.action === rteNotifyCommentAction.ANCHOR_COMMENT_ADD_NOTICE) {
                    const {
                        comment: {userId, comments},
                        member: {userId: curCommentUserId},
                    } = (data as any).data;
                    if (curCommentUserId === sdk.as.user?.userGuid) {
                        handleUnderLineCommentSendMsg({
                            rootComment: {
                                commentGuid: comments[0].commentId,
                                userGuid: userId,
                            },
                            commentGuid: comments[0].commentId,
                            anchorGuid: comments[0].commentId,
                        });
                    }
                }
                if (data.action === rteNotifyCommentAction.ANCHOR_COMMENT_NOTICE) {
                    const {
                        anchorComment: {userId = '', comments = []} = {},
                        comment: {commentId = ''} = {},
                        member: {userId: curCommentUserId = ''} = {},
                    } = (data as any).data;
                    if (!commentId || !comments.length || !userId) {
                        return;
                    }
                    if (curCommentUserId === sdk.as.user?.userGuid) {
                        handleUnderLineCommentSendMsg({
                            rootComment: {
                                commentGuid: comments[0].commentId,
                                userGuid: userId,
                            },
                            commentGuid: commentId,
                            anchorGuid: commentId,
                        });
                    }
                }
            }

            // if (type === rteNotifyType.CORE_API) {
            //     perfLogger.sourceAndApiError.logRteError((data as ICoreApiNotify).data?.error);
            // }

            if (type === rteNotifyType.ATTACHMENT) {
                const action = data.action;
                const actionMap: {
                    [x: string]: Exclude<
                        keyof EditorFile,
                        'key' | 'logger' | 'logWeb'
                    >;
                } = {
                    [`${rteNotifyAttachmentAction.UPLOAD_START}`]:
                        'uploadStart',
                    [`${rteNotifyAttachmentAction.UPLOAD_SUCCESS}`]:
                        'uploadSuccess',
                    [`${rteNotifyAttachmentAction.UPLOAD_FAIL}`]: 'uploadFail',
                    [`${rteNotifyAttachmentAction.DOWNLOAD_START}`]:
                        'downloadStart',
                    [`${rteNotifyAttachmentAction.DOWNLOAD_SUCCESS}`]:
                        'downloadSuccess',
                    [`${rteNotifyAttachmentAction.DOWNLOAD_FAIL}`]:
                        'downloadError',
                };
                const fuc = actionMap[action];
                fuc && perfLogger.editorFile[fuc](data.data);
                if (action === rteNotifyAttachmentAction.DOWNLOAD_SUCCESS) {
                    const info = (data as IAttachmentNotify).data;
                    const fileGuid = info.attachId || '';
                    const fileName = encodeURIComponent(
                        info?.fileInfo?.name || ''
                    );
                    getDownloadMessage(
                        repositoryGuid,
                        docGuid,
                        fileGuid,
                        fileName
                    );
                }
            }

            if (type === rteNotifyType.LOG) {
                // rte自主上报weblog
                rteWebLog((data as IRTEWeblog).data);
            }

            if (type === rteNotifyType.BUSINESSLOG) {
                // rte埋点上报，由rte触发，知识库层负责处理数据并上报
                switch (action) {
                    case EventNameMap.historyRevert:
                        reportRteEvent(EventNameMap.historyRevert, {
                            pageId: docGuid,
                            repoId: repositoryGuid,
                            groupId: groupGuid,
                        });
                        break;
                    default:
                        console.error(
                            `Not handle Rte ${rteNotifyType.BUSINESSLOG}`,
                            data
                        );
                        break;
                }
            }

            if (type === rteNotifyType.COMMENT_PERFORMANCE) {
                const isIconClick =
                    action === rteNotifyCommentPerformanceAction.ICON_CLICK;
                const isCommentPublish =
                    action ===
                    rteNotifyCommentPerformanceAction.COMMENT_PUBLISH;
                const commentPerformanceData =
                    data as ICommentPerformanceEditorNotify;
                isIconClick &&
                    perfLogger.underlineComment.handleCommentBtn(
                        commentPerformanceData.data
                    );
                isCommentPublish &&
                    perfLogger.underlineComment.handelSubmitBtn(
                        commentPerformanceData.data
                    );
            }

            if (type === rteNotifyType.HISTORY) {
                if (action === rteNotifyHistoryAction.PRESENTATION_START) {
                    store.setDemoMode(true);
                    reportDemoVersionClick();
                } else if (
                    action === rteNotifyHistoryAction.HISTORY_TAB_CHANGE
                ) {
                    const {currentTab} = data.data || {};
                    if (currentTab === 'version') {
                        reportCustomVersionTabClick();
                    }
                }
            }

            if (type === rteNotifyType.WS && window.navigator.onLine) {
                handleWebsocketStatus(action, data.data);
            }
            if (
                data.type === rteNotifyType.EDITOR &&
                data.action === rteNotifyCardEditAction.mergeCard
            ) {
                // remainedBlockId 合并后保留下来的id 对应接口的toBlockId removedBlockId合并后消失的id 对应接口的blockId
                handleCardMerge(data.data, docGuid, 1);
            }
            if (
                data.type === rteNotifyType.EDITOR &&
                data.action === rteNotifyCardEditAction.cardEventHover
            ) {
                userHoverCardLog();
            }
        },
        [
            mode,
            docGuid,
            repositoryGuid,
            groupGuid,
            isPreviewMode,
            handleAddCommentMentions,
            handleStartMeetingNotify,
            handleStopMeetingNotify,
            handlePublishSuccessNotify,
            handlePublishDraftNotify,
            handleRevertSuccess,
            handleModeChangeNotify,
            handleCollaboratorChange,
            handleEditorFirstChange,
            handleSave,
            // linkingReset,
            updateUnderLineCommentCount,
            getTagList,
            getFollowedInfo,
            handleTitleChange,
            handleUnderLineCommentSendMsg,
            scrollToDocumentPrePosition,
            showCompatibilityTips,
            callAfterDocRenderHook,
            getDownloadMessage,
            handleNotifyOfAgent,
            handleSetTitleNode,
        ]
    );

    const handleTplClick = useCallback(() => {
        setIsNew(false);
        setIsFirstPublish(true);
        updateHistoryState(history, {
            isEdit: false,
            isNew: false,
        });
    }, [history]);

    const handleDocLengthGet = useCallback(() => {
        const editor = editorRef.current;
        const len = editor ? editor.getDocLength() : 0;
        return len;
    }, []);

    useEffect(() => {
        async function getDocAllCardLikeNumInfo() {
            try {
                if (window.isTocPage) {
                    return;
                }
                const ksServer = await sdk.getKsServer();
                const {data, time = Date.now()} =
                    await ksServer.getDocAllCardLikeNumInfo({
                        repositoryGuid,
                        docGuid,
                    });
                store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
                    docGuid,
                    initTime: time,
                    likeInfoList: data,
                });
            } catch (err) {
                store.setData(store.KEYS.CUR_DOC_CARD_LIKES_INFO, {
                    docGuid,
                    initTime: Date.now(),
                    likeInfoList: [],
                });
                console.log(err);
            }
        }
        getDocAllCardLikeNumInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid, mode]);

    useEffect(() => {
        return () => {
            setShowStartMeetingDialog(false);
            setShowChangePermissionDialog(false);
            setShowDocDeleteDialog(false);
        };
    }, [isKuShareMode]);

    const editorHeadNode = useMemo(() => {
        return {
            left: (headerAdapterData: any) => {
                return curDocument ? (
                    <AdapterDataContext.Provider value={headerAdapterData}>
                        <WithAfterDocInfo
                            curDocument={curDocument}
                            mode={mode}
                            repository={repository}
                        />
                    </AdapterDataContext.Provider>
                ) : null;
            },
            right: (headerAdapterData: any) => {
                return (
                    <AdapterDataContext.Provider value={headerAdapterData}>
                        <WithAfterDocToolbar
                            repository={repository}
                            curDocument={curDocument}
                            mode={mode}
                            docGuid={docGuid}
                            editable={editable}
                            onPublish={verifiedEvents(handlePublish)}
                            onChangeEdit={verifiedEvents(handleChangeEdit)}
                            // 评论丢失优化小流量，非小流量用户保持以前逻辑，显示弹窗
                            onStopMeeting={isAutoSavedCommentGray ?
                                handleStopMeeting :
                                verifiedEvents(handleStopMeeting)
                            }
                            onStartMeeting={isAutoSavedCommentGray ?
                                handleStartMeetingMode :
                                verifiedEvents(handleStartMeetingMode)
                            }
                            onBackPreview={verifiedEvents(handleBackPreview)}
                            isFirstPublish={isFirstPublish}
                            setDocumentScrollPosition={
                                setDocumentScrollPosition
                            }
                            scrollToUserAnchorPosition={
                                scrollToUserAnchorPosition
                            }
                            isKuShareMode={isKuShareMode}
                            showCardViewGuide={showCardViewGuide}
                        />
                    </AdapterDataContext.Provider>
                );
            },
        };
    }, [
        curDocument,
        repository,
        mode,
        docGuid,
        editable,
        verifiedEvents,
        isKuShareMode,
        handlePublish,
        handleChangeEdit,
        handleStopMeeting,
        handleStartMeetingMode,
        handleBackPreview,
        isFirstPublish,
        setDocumentScrollPosition,
        scrollToUserAnchorPosition,
        showCardViewGuide,
        isAutoSavedCommentGray,
    ]);
    useEffect(() => {
        setHeaderSlot && setHeaderSlot(editorHeadNode);

        return () => {
            setHeaderSlot && setHeaderSlot(null);
        };
    }, [editorHeadNode, setHeaderSlot]);

    const starLinkEnable =
        sdk.as.user?.settings?.newSettings?.intelligent?.linking &&
        (isPreviewMode || isNormalMode);
    const highlightConfig = getHighlightConfig(!!starLinkEnable);
    function getEditor() {
        const editorLoading =
            !curDocument ||
            docGuid !== curDocument.docGuid ||
            reload === -1 ||
            isGettingDocData.current;
        const showBottomBar = isShowCurrentView(VIEW_BLOCK.bottomBar);
        return (
            <>
                <EditorTopTip
                    mode={mode}
                    showUnPublishTip={showUnPublishTip}
                    onShowUnPublishTipChange={setShowUnPublishTip}
                    isKuShareMode={isKuShareMode}
                    onSwitchEdit={() => {
                        if (isKuShareMode) {
                            handleStartMeetingMode().then();
                        } else {
                            handleSwitchEdit();
                        }
                    }}
                    showMeetingTip={showMeetingTipAlert}
                    meetingInfo={meetingInfo}
                />
                {editorLoading ? (
                    <Loading ref={loadingRef} />
                ) : (
                    <div className={styles.wrapper}>
                        {kuPiper.openNormalAddSlot({
                            scope: kuPiper.slotScopeMap.DocumentEditor,
                            position: kuPiper.slotPositionMap.DocumentEditor.EditorTop,
                        })}
                        <SquareEditAlert intl={intl} mode={mode} />
                        <Profiler
                            id={PROFILER_KEY.editor}
                            onRender={perfLogger.compRender.onRender}
                        >
                            <Editor
                                // 不知道为啥 ts过不去了
                                ref={editorRef as any}
                                curDocument={curDocument}
                                repository={repository}
                                isKuShareMode={isKuShareMode}
                                docGuid={docGuid}
                                mode={mode}
                                demoMode={demoMode}
                                hasEditPermission={editable}
                                isNew={isNew}
                                showIframeMask={showIframeMask}
                                onChangeMode={handleModeChange}
                                onTemplateClick={handleTplClick}
                                onRteNotify={handleRteNotify}
                                handleChange={handleChange}
                                // MARKS: 星链在屏幕中的埋点
                                highlightConfig={highlightConfig}
                                updateDoTitle={updateDoTitle}
                                pageSecuritySettings={pageSecuritySettings}
                                docForbidCopy={docForbidCopy}
                                docForbidPrint={docForbidPrint}
                                titleNode={titleNode}
                                docTitle={docTitle.current}
                            />
                        </Profiler>
                        {/* bottomBar 容器要先占位，否则编辑器内部的计算可能会有问题（例如表格的悬浮滚动条） */}
                        {kuPiper.openNormalReplaceSlot({
                            scope: kuPiper.slotScopeMap.DocumentEditor,
                            position: kuPiper.slotPositionMap.DocumentEditor.BottomBar,
                            DefaultComponent: showBottomBar ? (
                                <WithAfterBottomBar
                                    editable={editable}
                                    curDocument={curDocument}
                                    curRepository={repository}
                                    rootId={rootId}
                                />
                            ) : null,
                        })}
                    </div>
                )}
            </>
        );
    }
    return (
        <div className={styles.root}>
            {
                kuPiper.openNormalReplaceSlot({
                    scope: kuPiper.slotScopeMap.DocumentEditor,
                    position: kuPiper.slotPositionMap.DocumentEditor.Editor,
                    DefaultComponent: !error && getEditor(),
                })
            }
            <div className={styles.adminList} ref={listRef}>
                {showAdminList && <AdminMemberList onClose={handleCloseAdminList} data={adminList} />}
            </div>
            <NewVersionInfo
                curDocument={curDocument}
                mode={mode}
                onRefresh={handleClickRefresh}
            />
            <SaveTplDialog
                curDocument={curDocument}
                curRepository={repository}
            />
            <DocStatsDialog getDocLength={handleDocLengthGet} />
            <ConfirmDialog
                showCloseX={false}
                showHeader={false}
                showCancelButton={false}
                visible={showDocDeleteDialog}
                onConfirm={(event) => {
                    event.stopPropagation();
                    window.location.reload();
                }}
            >
                该文档已被删除
            </ConfirmDialog>
            <ConfirmDialog
                showCloseX={false}
                showHeader={false}
                showCancelButton={false}
                visible={showChangePermissionDialog}
                headline={intl.formatMessage({id: 'titleChangePermissionTip'})}
                onConfirm={(event) => {
                    event.stopPropagation();
                    window.location.reload();
                    setShowChangePermissionDialog(false);
                }}
            >
                {intl.formatMessage({id: 'changePermissionTip'})}
            </ConfirmDialog>
            <ConfirmDialog
                showCloseX={false}
                showHeader={false}
                showCancelButton={false}
                visible={showStartMeetingDialog}
                headline={intl.formatMessage({id: 'titleStartMeetingTip'})}
                onConfirm={(event) => {
                    event.stopPropagation();
                    setShowStartMeetingDialog(false);
                    window.location.reload(); // 直接刷新页面，兼容会议结束后才点击确定的情况
                }}
            >
                {meetingInfo?.creatorUser.name}
                启动了协作模式，你可进入协作模式查看最新内容
            </ConfirmDialog>
            <VerifyEditorDialog />
            {isKuShareMode && !showStartMeetingDialog ? (
                <KuShare editorRef={editorRef} editorMode={mode} />
            ) : null}
        </div>
    );
}

const DocumentPageImpl = store.connect<StoreProps, OwnProps>([
    store.KEYS.DOCUMENT_MODE,
    store.KEYS.DEMO_MODE,
    store.KEYS.ICAFE_RELATED_SHOW,
    store.KEYS.PAGE_SECURITY_SETTINGS,
    store.KEYS.IS_KU_SHARE_MODE,
])(DocumentPage);

export default DocumentPageImpl;
